import { useState, useEffect } from 'react';
import { footerApi } from '../utils/api';

// Module-level cache so Header, MiniNav and Footer share one request
let cache = null;
let inflight = null;

// localStorage cache — page reload/SPA navigation ma pani header logo/bg flicker nahos
const LS_KEY = 'kalo_site_settings';
const readLocal = () => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
const writeLocal = (s) => {
  try {
    if (s && typeof s === 'object') localStorage.setItem(LS_KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
};

const load = () => {
  if (!inflight) {
    inflight = footerApi
      .getSettings()
      .then((res) => {
        cache = res.data || {};
        writeLocal(cache);
        return cache;
      })
      .catch(() => {
        return cache || {};
      });
  }
  return inflight;
};

export const refreshSiteSettings = () => {
  cache = null;
  inflight = null;
  return load();
};

export function useSiteSettings() {
  // पहिलो render ma pani logo/bg turuntai — localStorage cache bata initialize
  const [settings, setSettings] = useState(cache || readLocal() || {});

  useEffect(() => {
    let mounted = true;
    load().then((s) => {
      if (mounted) setSettings(s || {});
    });
    return () => {
      mounted = false;
    };
  }, []);

  return settings;
}
